import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { StyledTooltip } from '../../../../../../../shared/components/StyledTooltip';
import { Text } from '../../../../../../../shared/components/Text';

export const KycFulfilledByMerchant = () => {
  const { palette } = useCustomTheme();
  return (
    <StyledTooltip
      title={
        <>
          <strong>
            <Text tId={'ONBOARDING_DETAILS'} />
          </strong>
          <hr />
          <Text tId={'FULFILLED_BY_MERCHANT_POS_DESCRIPTION'} />
        </>
      }
    >
      <i className="material-icons-outlined" style={{ fontSize: 26, color: palette.grey[600] }}>
        business
      </i>
    </StyledTooltip>
  );
};
